if (!customElements.get("product-review-summary")) {
  customElements.define(
    "product-review-summary",
    class ProductReviewSummary extends HTMLElement {
      connectedCallback() {
        this.widget = document.getElementById(this.dataset.widgetId);
        if (!this.widget) return;

        this.average = this.querySelector(".product-review-summary-average");
        this.count = this.querySelector(".product-review-summary-count");
        this.label = this.querySelector(".product-review-summary-label");
        this.bars = this.querySelectorAll(".product-review-summary-bar");

        // Judge.me renders its widget client-side, so read its data once it appears and whenever it changes.
        this.observer = new MutationObserver(() => this.update());
        this.observer.observe(this.widget, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["data-average-rating", "data-number-of-reviews", "data-frequency"],
        });
        this.update();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      update() {
        const summary = this.widget.querySelector(".jdgm-rev-widg[data-average-rating]");
        const total = parseInt(summary?.dataset.numberOfReviews, 10) || 0;

        this.hidden = total === 0;
        if (!total) return;

        const average = (parseFloat(summary.dataset.averageRating) || 0).toFixed(1);

        this.average.textContent = average;
        this.count.textContent = `(${total})`;
        this.label.textContent = this.dataset.label.replace("[rating]", average).replace("[total]", total);
        this.style.setProperty("--rating-percent", `${(average / 5) * 100}%`);

        this.bars.forEach((bar) => {
          const row = this.widget.querySelector(`.jdgm-histogram__row[data-rating="${bar.dataset.rating}"]`);
          const frequency = parseInt(row?.dataset.frequency, 10) || 0;
          const percent = Math.round((frequency / total) * 100);

          bar.style.setProperty("--bar-percent", `${percent}%`);
          bar.setAttribute(
            "aria-label",
            this.dataset.barLabel.replace("[stars]", bar.dataset.rating).replace("[percent]", percent),
          );
        });
      }
    },
  );
}
